var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlgorand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4390_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9638 23.996H20.2068L17.7668 14.9196L12.5208 23.997H8.32641L16.4347 9.94605L15.1297 5.06803L4.19638 24H0L13.8559 0H17.5295L19.1381 5.9628H22.9283L20.3405 10.4628L23.9638 23.996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4390_951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorand);
export default __webpack_public_path__ + "static/media/algorand.567707f71c0b69bcb5d2b52c083de69d.svg";
export { ForwardRef as ReactComponent };